// Bare numbers are decimal hours; unit-based values and H:MM avoid decimal arithmetic for users.
export function parseDurationHours(value) {
    const text = String(value).trim().toLowerCase();
    let hours;
    if (/^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(text)) {
        hours = Number(text.replace(",", "."));
    } else {
        const clock = text.match(/^(\d+):([0-5]\d)$/);
        const units = text.match(/^(?:(\d+(?:[.,]\d+)?)\s*h)?\s*(?:(\d+)\s*m)?$/);
        if (clock) {
            hours = Number(clock[1]) + Number(clock[2]) / 60;
        } else if (units && (units[1] !== undefined || units[2] !== undefined)) {
            hours = Number((units[1] || "0").replace(",", ".")) + Number(units[2] || 0) / 60;
        } else {
            return null;
        }
    }
    return Number.isFinite(hours) ? hours : null;
}

export function durationLabel(hours) {
    const minutes = hours * 60;
    // Ignore binary floating-point noise in the label, without changing the submitted hours.
    const wholeMinutes = Math.round(minutes);
    if (Math.abs(minutes - wholeMinutes) < 1e-8) {
        const wholeHours = Math.floor(wholeMinutes / 60);
        const remainingMinutes = wholeMinutes % 60;
        return [wholeHours ? `${wholeHours} klst.` : "", remainingMinutes ? `${remainingMinutes} mín.` : ""].filter(Boolean).join(" ");
    }
    return `${hours.toLocaleString("is-IS", { maximumSignificantDigits: 15 })} klst.`;
}
